import { render, staticRenderFns } from "./ReservationCard.vue?vue&type=template&id=c1e1c298&"
import script from "./ReservationCard.vue?vue&type=script&lang=js&"
export * from "./ReservationCard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports